var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPodcast(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 25 25",
    style: {
      enableBackground: "new 0 0 25 25"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M17.3,12.8c0,2.5-1.9,4.6-4.3,4.9v3h1.5c0.4,0,0.7,0.3,0.7,0.7s-0.3,0.7-0.7,0.7h-4.3c-0.4,0-0.7-0.3-0.7-0.7 s0.3-0.7,0.7-0.7h1.5v-3c-2.4-0.3-4.3-2.4-4.3-4.9c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7c0,2,1.6,3.6,3.6,3.6 c2,0,3.6-1.6,3.6-3.6c0-0.4,0.3-0.7,0.7-0.7C17,12.2,17.3,12.5,17.3,12.8 M12.1,15h0.4c1.5,0,2.7-1.2,2.7-2.7V6.2 c0-0.4-0.3-0.7-0.7-0.7c-0.4,0-0.7,0.3-0.7,0.7v6.1c0,0.7-0.6,1.3-1.3,1.3h-0.4c-0.7,0-1.3-0.6-1.3-1.3V5.6c0-0.7,0.6-1.3,1.3-1.3 h0.4c0.2,0,0.3,0,0.5,0.1c0.3,0.1,0.7,0,0.9-0.4c0.1-0.3,0-0.7-0.4-0.9c-0.3-0.1-0.6-0.2-1-0.2h-0.4c-1.5,0-2.7,1.2-2.7,2.7v6.7 C9.4,13.8,10.6,15,12.1,15"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPodcast);
export default __webpack_public_path__ + "static/media/podcast.09c9e3f82ca109b57f027e32a4f7009f.svg";
export { ForwardRef as ReactComponent };